<div class="game">
  <div class="ball" [style.background-image]="statesService.backgroundImageSrc"></div>
  <div class="buddy">
    <div class="body"></div>
    <div class="tail"></div>
  </div>
</div>
